import * as Sentry from '@sentry/angular';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { AppointmentComponent } from './appointment/appointment.component';
//import { LoadingInterceptor } from './app.component.service';
import { LoadingService } from './service/loading.service';
import { PopupService } from './service/popup.service';
import { BrandService } from './service/brand.service';
import { HelperService } from './service/helper.service';
import { AppointmentEmptyComponent } from './appointment-empty/appointment-empty.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { AppointmentConfirmComponent } from './appointment-confirm/appointment-confirm.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    AppointmentComponent,
    AppointmentEmptyComponent,
    TestimonialComponent,
    AppointmentConfirmComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    FormsModule,
    ReactiveFormsModule,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  RouterModule.forRoot([
    { path: '', component: AppointmentEmptyComponent, pathMatch: 'full' },
    { path: ':contactid', component: AppointmentComponent, pathMatch: 'full' },
    { path: 'appointment/:userid/:contactid', component: AppointmentComponent, pathMatch: 'full' },
    { path: 'appointment/:appointmentid', component: AppointmentConfirmComponent, pathMatch: 'full' },
    { path: ':sourceId', component: AppointmentEmptyComponent },
    { path: ':contactid/:eb', component: AppointmentComponent },
  ])], providers: [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    //{ provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    LoadingService,
    PopupService,
    BrandService,
    HelperService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
